import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import convertBitToBytes from '../../../../../utils/convertBitToBytes.utils';
import TorrentService from '../../../Torrent.service';
import './TorrentCard.css';
export default function TorrentCard({torrent, isDeletable, isShareable, isUserVisible}) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isShare, setIsShared] = useState(torrent.shared);

    useEffect(() => {
        setIsShared(torrent.shared);
    }, [torrent.shared]);

    const goToDetail = () => {
        navigate(`/torrent/${torrent._id}`);
    };

    const updateShare = (ev) => {
        TorrentService.updateShare(dispatch, torrent._id, ev.target.checked);
    };

    const remove = (ev) => {
        ev.stopPropagation();
        TorrentService.delete(dispatch, torrent._id);
    };

    return <div className='TorrentCard' onClick={goToDetail}>
        <div className='TorrentCard-name'>{torrent.datas.name}</div>
        <div className='TorrentCard-size TorrentCard-item'><span className='TorrentCard-label'>Taille:</span><span className='TorrentCard-value'>{convertBitToBytes(torrent.datas.size)}</span></div>
        <div className='TorrentCard-uploaded TorrentCard-item'><span className='TorrentCard-label'>Uploadé:</span><span className='TorrentCard-value'>{convertBitToBytes(torrent.datas.uploaded)}</span></div>
        <div className='TorrentCard-date TorrentCard-item'><span className='TorrentCard-label'>Date d'ajout:</span><span className='TorrentCard-value'>{dayjs(torrent.date).format('DD/MM/YYYY')}</span></div>
        <div className='TorrentCard-url TorrentCard-item'><span className='TorrentCard-label'>Tracker:</span><span className='TorrentCard-value'><a onClick={(ev) => ev.stopPropagation()} href={torrent.url}>{torrent.source}</a></span></div>
        {isShareable && <div className='TorrentCard-shared TorrentCard-item'>
            <span className='TorrentCard-label'>Partagé:</span><input className='TorrentCard-value' type="checkbox" checked={isShare} onChange={updateShare} onClick={(ev) => ev.stopPropagation()}/>
        </div>}
        {isDeletable && <div className='TorrentCard-item TorrentCard-remove'><button className='block sm danger' onClick={remove}>Supprimer</button></div>}
        {isUserVisible && <div className='TorrentCard-item'><span className='TorrentCard-label'>Utilisateur:</span><span className='TorrentCard-value'>{torrent.user.name}</span></div>}
    </div>
}